import { Injectable, OnDestroy } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subscription } from 'rxjs';
import { watch } from 'rxjs-watcher';
import { HWCInfo, TillDrawer } from '../shared/model/HWCInfo.model';
import { TMaxUpdateInfo } from '../shared/model/TMaxUpdateInfo.model';
import { AppointmentBookService } from './appointment-book.service';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root'
})
export class SignalRService implements OnDestroy {

  public HWCUrl: string = "http://AS365HWC";
  public minHWCVersion: string = "1.0.0.0";  // This comes from Default Data
  public SPAVersion: string = "1.0.0.0";
  public hub: signalR.HubConnection;
  public hwcInfo: HWCInfo;

  subList: Subscription[] = [];

  public TMaxSignalRHub: Observable<signalR.HubConnection>;

  constructor(public events: EventService, private aptManager: AppointmentBookService) {
    console.log("SignalR Service");

    this.subList.push(this.events.onRebootHWCDevice
      // .pipe(watch("SignalR Service - Reboot HWC Device"))
      .subscribe(r => {
        this.RebootHWCDevice(r);
      }));


    this.subList.push(this.events.onRestartHWCService
      // .pipe(watch("SignalR Service - Restart HWC Service"))
      .subscribe(r => {
        this.RestartHWCService(r);
      }));

    this.subList.push(this.events.onSaveTMaxSessionCounts
      // .pipe(watch("SignalR Service - OnResetBed"))
      .subscribe(r => {
        this.SaveTMaxSessionCounts();
      }));

    this.subList.push(this.events.onResetBed
      // .pipe(watch("SignalR Service - OnResetBed"))
      .subscribe(r => {
        if (r) {
          console.log("Reset Resource");
          this.TMaxResetBed(r.NetworkId).then((rc) => {
            console.log("Reset Resource - HWC returned", rc);
            if (r.ContinueFunc) r.ContinueFunc(rc);
            this.events.AptDataUpdated(r.NetworkId);
          });
        }
      }));

    this.subList.push(this.events.onStopBed
      // .pipe(watch("SignalR Service - OnStopBed "))
      .subscribe(r => {
        if (r) {
          console.log("Stop Resource");
          this.TMaxStopBed(r.NetworkId, r.AppointmentId).then(rc => {
            console.log("Resource Stopped - HWC returned", rc);
            if (r.ContinueFunc) r.ContinueFunc(rc);
            this.events.AptDataUpdated(r.AppointmentId);
          });
        }
      }));

    this.subList.push(this.events.onOpenTillDrawer
      // .pipe(watch("SignalR Service - OnOpenTilDrawer"))
      .subscribe(TillId => {
        if (TillId) {
          this.OpenTillDrawer(TillId).then(rc => {
            // console.log("Till Drawer Open - HWC returned" + rc);
          });
        }
      }));

    this.subList.push(this.events.onStartBed
      // .pipe(watch("SignalR Service - OnStartBed"))
      .subscribe(r => {         
        if (r) {
          console.log("Start Bed NetworkId "+r.NetworkId +" delay "+r.Delay + " duration "+r.Duration+"s");
          this.TMaxStartBed(r.NetworkId, r.Delay, r.Duration, r.AppointmentId).then(rc => {
            console.log("Start Bed - HWC returned", rc);
            if (r.ContinueFunc) 
            {
              console.log("Start Bed Calling Continue Function");
              r.ContinueFunc(rc);
            }
            console.log("Event Apt Data Updated");
            this.events.AptDataUpdated(r.AppointmentId);
          });
        }
      }));

    this.subList.push(this.events.onHWCFound      
      .subscribe(r => {
        if (r) {
          // HWC Found          
          this.hwcInfo = r;
          this.HWCUrl = r.HWCUrl;
          this.minHWCVersion = r.Version;          
          this.SPAVersion =this.events.WebAPIVersion;

          var options = {
            transport: signalR.HttpTransportType.WebSockets,
            logging: signalR.LogLevel.Trace,
            skipNegotiation: true,
          };

          this.hub = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)
            .withUrl(this.HWCUrl + '/tmaxhub?SPAVersion=' + this.SPAVersion +"&minHWCVersion=" + this.minHWCVersion + "&WebApiUrl=" + window.location.host, options) // the SignalR server url
            .withAutomaticReconnect()
            .build();          
          this.hub.keepAliveIntervalInMilliseconds = 1000 * 5;  // Ping the server every 5 seconds - This keeps the server aware of this client (Client to Server)
          this.hub.serverTimeoutInMilliseconds = 1000 * 30;     // Terminate connection after 30 seconds of no contact with server (Server to Client)

          // register for TMaxStatusUpdate data
          this.hub.on('TMaxStatusUpdate', (a: TMaxUpdateInfo) => {
            // If we get this, we are connected.            
            this.events.TMaxUpdate(a);
          });

          this.hub.on('TillDrawerOpened', (a: TillDrawer) => {
            // If we get this, we are connected.
            // console.log('Till Drawer Opened' + a);
          });

          // This gets called when SignalR connection is first made
          this.hub.on('HWCInfo', (r: HWCInfo) => {
            console.log("Found and Connected to HWC");
            console.log(r);
            
            this.hwcInfo = r;
            this.events.HWCConnected(r);
          });

          this.hub.onclose(error => {
            console.log('SignalR Connection closed : ' + error);
            this.hwcInfo = null;
            this.events.HWCDisconnected();
          });
          this.hub.onreconnected(id => {
            console.log('SignalR reconnected: ' + id);
            
            this.events.HWCConnected(this.hwcInfo);
          });
          this.hub.onreconnecting(error => {
            console.log('SignalR reconnecting: ' + error);
            this.hwcInfo = null;
            this.events.HWCDisconnected();
          });

          // Start SignalR connection to server (HWC)
          this.TMaxSignalRHub = this.StartConnection();

          this.TMaxSignalRHub
            // .pipe(watch("SignalR Service - TMaxSignalRHub"))
            .subscribe(c => {
              if (c && c.state === signalR.HubConnectionState.Connected) {
                
                this.events.HWCConnected(this.hwcInfo);
              } else {
                console.log('SignalR not connected');
              }
            });
        }
      }));
  }

  ngOnDestroy() {
    if (this.subList) {
      this.subList.forEach(s => s?.unsubscribe());
      this.subList = [];
    }
  }

  public StartConnection(): Observable<signalR.HubConnection> {

    // https://luukgruijs.medium.com/understanding-creating-and-subscribing-to-observables-in-angular-426dbf0b04a3
    const simpleObservable = new Observable<signalR.HubConnection>((observer) => {
      // observable execution
      if (this.hub.state == signalR.HubConnectionState.Connected)
        observer.next(this.hub);
      else {
        this.hub
          .start()
          .then(() => {
            console.log(`SignalR connection success! connectionId: ${this.hub.connectionId} `);
            observer.next(this.hub);
          })
          .catch((error) => {
            console.log(`SignalR connection error: ${error}`);
            observer.next(null);
          });
      }
    });

    return simpleObservable;
  }

  public RebootHWCDevice(BranchCode) {
    if (!BranchCode)
      return;

    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();

    return this.hub.invoke("RebootDevice", BranchCode);
  }

  public RestartHWCService(BranchCode) {
    if (!BranchCode)
      return;

    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();

    return this.hub.invoke("RestartService", BranchCode);
  }

  public SaveTMaxSessionCounts() {
    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();

    return this.hub.invoke("SaveTMaxSessionCounts");
  }

  public TMaxStartBed(DeviceId: number, Delay: number, Duration: number, aptId: number): Promise<any> {    
    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();
    return this.hub.invoke("StartBedV2", DeviceId, Delay, Duration, aptId,false);
  }

  public TMaxResetBed(DeviceId: number): Promise<any> {

    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();

    return this.hub.invoke("ResetBedV2", DeviceId,false);
  }

  public TMaxStopBed(DeviceId: number, AppointmentId: number): Promise<any> {

    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();

    return this.hub.invoke("StopBedV2", DeviceId, AppointmentId,false);
  }

  public OpenTillDrawer(TillId: number) {
    // Reconnect if not connected. Needed if we refresh page?
    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();
    return this.hub.invoke("OpenTillDrawerV2", TillId,false);
  }

  public DoUpdateCheck() {
    // Reconnect if not connected. Needed if we refresh page?
    if (this.hub.state != signalR.HubConnectionState.Connected)
      this.hub.start();
  } 
}